import { getAuth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { getCurrentDb } from "./firebaseInit";

export function getAuthInstance() {
  const db = getCurrentDb();
  return getAuth(db.app); // attach to correct app
}

export const auth = getAuthInstance();

export const createUser = async (email) => {
    let userData = null;
    try {
        userData = await createUserWithEmailAndPassword(auth, email, Math.random().toString(36).slice(2, 10));
        await sendPasswordResetEmail(auth, email);
    } catch {
        userData = null;
    };
    return userData;
}

export const login = async (email, password) => {
    return await signInWithEmailAndPassword(auth, email, password);
}

export const logout = async () => {
    return await signOut(auth);
}

export const resetPassword = async (email) => {
    return sendPasswordResetEmail(auth, email);
}
